import React, { useMemo } from 'react';

import { Stack } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';
import { useQuery } from '@tanstack/react-query';

import { EditRemoveBtn } from 'components/buttons';
import { PanelGrid } from 'components/grid';
import { Block, OneColumn } from 'components/page';
import { FormFilterDepositos } from 'pages/complementar/depositos/components/templates/FormFilterDepositos';
import { useListagemContext } from 'context/ListagemContext';
import { RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';

const generateDepositosList = (data: any[] | undefined): GridRowsProp => {
    const list = data;

    if (Array.isArray(list) && list.length) {
        return list.map((item, index) => ({
            id: index + 1,
            idDeposito: item.idDeposito,
            dsDeposito: item.dsDeposito,
            cdDeposito: item.cdDeposito,
            fgAtivo: item.fgAtivo,
        }));
    }
    return [];
};

export function DepositosListComp() {
    const { filter, page, sort, limit } = useListagemContext();
    const RequestListagem = useRequestListagem();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/deposito',
        sort: sort && sort.length > 0 ? sort : [{ property: 'idDeposito', direction: 'DESC' }],
        columns: 'idDeposito,dsDeposito,cdDeposito,fgAtivo',
        nested: true,
        filter: [...filter, { property: 'fgAtivo', value: true, operator: 'eq' }],
        page,
        limit,
    };

    const { fetchStatus, data, refetch } = useQuery([requestOptions], () => {
        const request: Promise<any> = RequestListagem(requestOptions).then((res: any) => res.data);
        return request;
    });

    const columns: GridColDef[] = useMemo(
        () => [
            { field: 'idDeposito', headerName: 'Código', alignItems: 'center', flex: 1, type: 'string' },
            { field: 'dsDeposito', headerName: 'Descrição', alignItems: 'center', flex: 1, type: 'string' },
            { field: 'cdDeposito', headerName: 'Código de Integração', alignItems: 'center', flex: 1, type: 'string' },
            {
                field: 'acoes',
                align: 'center',
                headerAlign: 'center',
                headerName: 'Ações',
                filterable: false,
                sortable: false,
                hideable: false,
                disableColumnMenu: true,
                width: 110,
                renderCell: ({ row }) => (
                    <EditRemoveBtn
                        id={row.idDeposito}
                        showEditBtn={true}
                        showRemoveBtn={true}
                        removeUrl={`gestao/deposito/${row.idDeposito}`}
                        sx={{ ml: 'auto', p: 1.5 }}
                        refresh={refetch}
                    />
                ),
            },
        ],
        [refetch],
    );

    const rows = generateDepositosList(data?.data);

    return (
        <OneColumn title="Depósitos" createButton>
            <FormFilterDepositos />

            <Block>
                <PanelGrid rows={rows} rowsCount={data?.total ?? 0} reload={refetch} loading={fetchStatus === 'fetching'} columns={columns} />
            </Block>
        </OneColumn>
    );
}
